import { AxiosError } from "axios";
import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  COMPLETED_SLP_LIST_PDF_REQUEST,
  COMPLETED_SLP_LIST_REQUEST,
  PLA_USER_LIST_REQUEST,
  SLP_REQUESTS_PDF_REQUEST,
  SLP_REQUESTS_REQUEST,
  UPDATE_SLP_CONTACT_NOTE_REQUEST,
  UPDATE_SLP_CONTACT_PROGRESS_REQUEST,
  UPDATE_SLP_PARTICIPATION_REQUEST,
  VIEW_SLP_GOALS_ASSESSMENT_PDF_REQUEST,
} from "./actionTypes";
import {
  completedSLPListFailure,
  completedSLPListPDFSuccess,
  completedSLPListSuccess,
  plaUserListFailure,
  plaUserListSuccess,
  slpRequestsFailure,
  slpRequestsPDFFailure,
  slpRequestsPDFSuccess,
  slpRequestsSuccess,
  updateSLPContactNoteFailure,
  updateSLPContactNoteSuccess,
  updateSLPContactProgressFailure,
  updateSLPContactProgressSuccess,
  updateSLPParticipationFailure,
  updateSLPParticipationSuccess,
  viewSLPGoalsAssessmentPDFFailure,
  viewSLPGoalsAssessmentPDFSuccess,
} from "./actions";
import slpService from "./service";
import {
  CompletedSLPListPDFRequest,
  CompletedSLPListPDFResponse,
  CompletedSLPListRequest,
  CompletedSLPListResponse,
  PLAUserListRequest,
  PLAUserListResponse,
  SLPRequestsPDFRequest,
  SLPRequestsPDFResponse,
  SLPRequestsRequest,
  SLPRequestsResponse,
  UpdateSLPContactNoteRequest,
  UpdateSLPContactNoteResponse,
  UpdateSLPContactProgressRequest,
  UpdateSLPContactProgressResponse,
  UpdateSLPParticipationRequest,
  UpdateSLPParticipationResponse,
  ViewSLPGoalsAssessmentPDFRequest,
  ViewSLPGoalsAssessmentPDFResponse,
} from "./type";

function* slpRequestsSaga(action: SLPRequestsRequest) {
  try {
    const response: SLPRequestsResponse = yield call(
      slpService.getSLPRequests,
      action.payload.values
    );

    const paginationDetails = {
      nextPage: response.item.nextPage,
      prevPage: response.item.prevPage,
      totalCount: response.item.totalRecordCount,
      totalPages: response.item.pageCount,
    };

    yield put(
      slpRequestsSuccess({
        slpRequests: response.item.records,
        slpRequestsPagination: paginationDetails,
      })
    );
    action.payload.callback({
      slpRequests: response.item.records,
      slpRequestsPagination: paginationDetails,
    });
  } catch (error) {
    yield put(
      slpRequestsFailure({
        error: (error as AxiosError).message,
      })
    );
  }
}

function* plaUserListSaga(action: PLAUserListRequest) {
  try {
    const response: PLAUserListResponse = yield call(slpService.getPLAUserList);

    yield put(
      plaUserListSuccess({
        userList: response.item,
      })
    );
    action.payload.callback({
      userList: response.item,
    });
  } catch (error) {
    yield put(
      plaUserListFailure({
        error: (error as AxiosError).message,
      })
    );
  }
}

function* slpRequestsPDFSaga(action: SLPRequestsPDFRequest) {
  try {
    const response: SLPRequestsPDFResponse = yield call(
      slpService.getSLPRequestsPDF,
      action.payload.values
    );

    yield put(
      slpRequestsPDFSuccess({
        slpRequestPDF: response.item,
      })
    );
    action.payload.callback({
      slpRequestPDF: response.item,
    });
  } catch (error) {
    yield put(
      slpRequestsPDFFailure({
        error: (error as AxiosError).message,
      })
    );
  }
}

function* updateSLPContactProgressSaga(
  action: UpdateSLPContactProgressRequest
) {
  try {
    const response: UpdateSLPContactProgressResponse = yield call(
      slpService.updateSLPContactProgress,
      action.payload.value
    );

    yield put(
      updateSLPContactProgressSuccess({
        contactProgress: response.item,
      })
    );
    action.payload.callback();
  } catch (error) {
    yield put(
      updateSLPContactProgressFailure({
        error: (error as AxiosError).message,
      })
    );
  }
}

function* completedSLPListSaga(action: CompletedSLPListRequest) {
  try {
    const response: CompletedSLPListResponse = yield call(
      slpService.getCompletedSLPList,
      action.payload.values
    );

    const paginationDetails = {
      nextPage: response.item.nextPage,
      prevPage: response.item.prevPage,
      totalCount: response.item.totalRecordCount,
      totalPages: response.item.pageCount,
    };

    yield put(
      completedSLPListSuccess({
        completedSLPs: response.item.records,
        completedSLPsPagination: paginationDetails,
      })
    );
    action.payload.callback({
      completedSLPs: response.item.records,
      completedSLPsPagination: paginationDetails,
    });
  } catch (error) {
    yield put(
      completedSLPListFailure({
        error: (error as AxiosError).message,
      })
    );
  }
}

function* completedSLPRequestPDFSaga(action: CompletedSLPListPDFRequest) {
  try {
    const response: CompletedSLPListPDFResponse = yield call(
      slpService.getCompletedSLPListPDF,
      action.payload.values
    );

    yield put(
      completedSLPListPDFSuccess({
        completedSLPsPDF: response.item,
      })
    );
    action.payload.callback({
      completedSLPsPDF: response.item,
    });
  } catch (error) {
    yield put(
      completedSLPListFailure({
        error: (error as AxiosError).message,
      })
    );
  }
}

function* updateSLPParticipationSaga(action: UpdateSLPParticipationRequest) {
  try {
    const response: UpdateSLPParticipationResponse = yield call(
      slpService.updateSLPParticipation,
      action.payload.value
    );

    yield put(
      updateSLPParticipationSuccess({
        participation: response.item,
      })
    );
    action.payload.callback();
  } catch (error) {
    yield put(
      updateSLPParticipationFailure({
        error: (error as AxiosError).message,
      })
    );
  }
}

function* updateSLPContactNoteSaga(action: UpdateSLPContactNoteRequest) {
  try {
    const response: UpdateSLPContactNoteResponse = yield call(
      slpService.updateSLPContactNote,
      action.payload.value
    );

    yield put(
      updateSLPContactNoteSuccess({
        contactNote: response.item,
      })
    );
    action.payload.callback(response.item);
  } catch (error) {
    yield put(
      updateSLPContactNoteFailure({
        error: (error as AxiosError).message,
      })
    );
  }
}

function* viewSLPGoalsAssessmentPDFSaga(
  action: ViewSLPGoalsAssessmentPDFRequest
) {
  try {
    const response: ViewSLPGoalsAssessmentPDFResponse = yield call(
      slpService.viewSLPGoalsAssessmentPDF,
      action.payload.value
    );

    yield put(
      viewSLPGoalsAssessmentPDFSuccess({
        goalsAssessmentPDF: response.item,
      })
    );
    action.payload.callback({
      goalsAssessmentPDF: response.item,
    });
  } catch (error) {
    yield put(
      viewSLPGoalsAssessmentPDFFailure({
        error: (error as AxiosError).message,
      })
    );
  }
}

function* slpDashboardSaga() {
  yield all([takeLatest(SLP_REQUESTS_REQUEST, slpRequestsSaga)]);
  yield all([takeLatest(PLA_USER_LIST_REQUEST, plaUserListSaga)]);
  yield all([takeLatest(SLP_REQUESTS_PDF_REQUEST, slpRequestsPDFSaga)]);
  yield all([
    takeLatest(
      UPDATE_SLP_CONTACT_PROGRESS_REQUEST,
      updateSLPContactProgressSaga
    ),
  ]);
  yield all([takeLatest(COMPLETED_SLP_LIST_REQUEST, completedSLPListSaga)]);
  yield all([
    takeLatest(COMPLETED_SLP_LIST_PDF_REQUEST, completedSLPRequestPDFSaga),
  ]);
  yield all([
    takeLatest(UPDATE_SLP_PARTICIPATION_REQUEST, updateSLPParticipationSaga),
  ]);
  yield all([
    takeLatest(UPDATE_SLP_CONTACT_NOTE_REQUEST, updateSLPContactNoteSaga),
  ]);
  yield all([
    takeLatest(
      VIEW_SLP_GOALS_ASSESSMENT_PDF_REQUEST,
      viewSLPGoalsAssessmentPDFSaga
    ),
  ]);
}

export default slpDashboardSaga;
